import React, { useState } from 'react';
import './FinancialReport.css';
import { Button, Card } from 'react-bootstrap';
import { BsLayoutTextSidebarReverse } from "react-icons/bs";
import { BsArrowsAngleExpand } from "react-icons/bs";
import { BsArrowsAngleContract } from "react-icons/bs";
import FilterGraphicFinincs from '../FilterGraphicFinincs';
import Charts from '../Charts';

const FinancialReport = () => {
    const [expand, setExpand] = useState(true)

    return (
        <>
            {expand && (<Card> <Card.Body> <FilterGraphicFinincs /> <Charts /> </Card.Body>  </Card>)}
            <br></br>
            <Card>
                <Card.Header><Card.Title>
                    <div className='d-flex align-items-center justify-content-between'>
                        <h5 className='d-flex align-items-center text-secondary'>
                            <BsLayoutTextSidebarReverse style={{ marginRight: "8px" }} />
                            Mês de Janeiro / 2024
                        </h5>
                        {
                            expand ? (<Button variant='secondary' onClick={() => { setExpand(false) }}>
                                <BsArrowsAngleContract style={{ fontWeight: "bolder" }} />

                            </Button>) : (<Button variant='secondary' onClick={() => { setExpand(true) }}>
                                <BsArrowsAngleExpand style={{ fontWeight: "bolder" }} />
                            </Button>)
                        }
                    </div>

                </Card.Title>
                </Card.Header>
                <Card.Body>
                    <div className={expand ? 'tabel-financs' : 'tabel-active-financs'}>
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th scope="col">Data da Transação</th>
                                    <th scope="col">N° Pedido</th>
                                    <th scope="col">Comprador</th>
                                    <th scope="col">Descrição</th>
                                    <th scope="col">Pagamento</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Mês de Competência</th>
                                    <th scope="col">Observações </th>
                                    <th scope="col">Nota Fiscal</th>
                                    <th scope="col">Valor Total</th>
                                </tr>
                            </thead>

                            <tbody style={{ cursor: "pointer" }}>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                                <tr>
                                    <th scope="row">07/10/2024 - 13:20</th>
                                    <td>#15</td>
                                    <td>Ênio Freitas da Silva</td>
                                    <td>Descrição da Compra</td>
                                    <td>Cartão Crédito</td>
                                    <td>Finalizado</td>
                                    <td>JAN</td>
                                    <td>Observação Do Pedido</td>
                                    <td>NF</td>
                                    <td>R$ 250,00</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </Card.Body>
            </Card>
        </>
    )
}

export default FinancialReport